import { Component, OnInit, Input } from '@angular/core';
import { WinService } from 'src/app/services/win.service';
import { ProductService } from 'src/app/services/api/product.service';

@Component({
  selector: 'app-matte-icon',
  templateUrl: './matte-icon.component.html',
  styleUrls: ['./matte-icon.component.scss']
})
export class MatteIconComponent implements OnInit {

	@Input() product: any = null;
	@Input() bg: any = null;

	constructor(
		public productService: ProductService,
		public winService: WinService
	) { }

	ngOnInit() {
	}

}
